<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <!-- 1.内容 -->
    <div class="growth_rules global-felx">
      <!-- 2.标题 -->
      <y-title label="基础成长值"></y-title>
      <!-- 2.表单区域 -->
      <div class="item-box">
        <el-form :model="form" label-width="125px" label-position="right">
          <el-form-item label="成长值别名：" prop="ruleName">
            <el-input
              v-model="form.ruleName"
              placeholder="成长值"
              maxlength="4"
              size="small"
              show-word-limit
              style="width: 150px"
            ></el-input>
          </el-form-item>

          <el-form-item label="基准规则：" required>
            每消费<el-input
              v-model="form.baseMoney"
              v-numHave2Decimal
              style="width: 100px;margin:0px 8px;"
              @blur="handleMoney"
              placeholder="请输入"
            ></el-input>
            <span>元(不含邮费)，获得</span>
            <el-input
              v-numZOnly
              v-model="form.baseGrowVal"
              style="width: 100px; margin: 0 8px"
              placeholder="请输入"
            >
            </el-input>
            <span>成长值</span>
          </el-form-item>

          <el-form-item label="商品选择：" required="" prop="itemSelectType">
            <el-radio-group v-model="form.itemSelectType">
              <!-- 第一个选项：‘不限’为默认选择 -->
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1"
                ><span @click="goodsState = true"
                  >包含特定商品<span v-if="form.itemSelectType == 1"
                    >（{{ goodsArr.length }}）</span
                  ></span
                ></el-radio
              >
              <el-radio :label="2"
                ><span @click="goodsState = true"
                  >排除特定商品<span v-if="form.itemSelectType == 2"
                    >（{{ goodsArr.length }}）</span
                  ></span
                ></el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="发放规则：">
            <span>订单交易成功后，立即发放</span>
          </el-form-item>

          <el-form-item label="成长值取整方式：">
            <span>向下取整。举例：1545.9 分 取整为1545 分</span>
          </el-form-item>
        </el-form>
      </div>

      <!-- 3.标题 -->
      <y-title label="成长值扣减规则" style="margin-top: 30px"></y-title>
      <!-- 3.表单区域 -->
      <div class="item-box">
        <el-form :model="form" label-position="right" style="margin-left: 19px">
          <el-form-item label="">
            <el-radio-group v-model="form.costType">
              <!-- 默认选中 不扣减成长值-->
              <el-radio :label="0">不扣减成长值</el-radio>
              <y-tip style="width: fit-content; margin: 12px">发放奖励积分后，会员再想进行退款时，不做奖励积分扣除。</y-tip
              >
              <el-radio :label="1" v-model="selectedValue"
                >按退款比例扣减成长值</el-radio
              >
              <y-tip style="width: fit-content; margin: 12px">
                <div>
                  1.计算退款金额占订单实付金额的比例，根据此比例扣除对应订单已发放成长值，成长值为小数时按照系统配置取整方式取整。
                </div>
                <div>
                  2.包含多笔子订单多次退款时，按照每笔实际退款金额计算扣除相应的成长值。
                </div>
              </y-tip>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <!-- 4.标题 -->
      <y-title label="成长值有效期" style="margin-top: 30px"></y-title>
      <!-- 4.表单区域 -->
      <div class="item-box" style="margin-left: 19px">
        <el-radio-group v-model="form.validType">
          <!-- 默认选中 选中永久有效 -->
          <el-radio :label="0">永久有效</el-radio>
          <br />

          <el-radio :label="1" style="margin-top: 16px">
            <el-input
              v-model="form.num11"
              style="width: 100px; height: 32px; margin-right: 8px"
              @input="handleNumInput"
            ></el-input>
            <el-select
              style="width: 100px; height: 32px; margin-right: 8px"
              v-model.trim="form.num12"
            >
              <el-option
                v-for="item in YTD"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
            <span>后失效</span>
          </el-radio>
          <br />

          <el-radio :label="4" style="margin-top: 16px">
            <el-select
              style="width: 100px; height: 32px; margin-right: 8px"
              v-model.trim="form.num2"
            >
              <el-option
                v-for="item in currentYT"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
            <span>底失效</span>
          </el-radio>
          <br />

          <el-radio :label="6" style="margin-top: 16px">
            <el-select
              style="width: 100px; height: 32px; margin-right: 8px"
              v-model="form.num31"
            >
              <el-option
                v-for="item in fourmouth"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
            <span>月后的</span>
            <el-select
              style="width: 100px; height: 32px; margin: 0 8px"
              v-model="form.num32"
            >
              <el-option
                v-for="item in fourday"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
            <span>日失效</span>
          </el-radio>
          <br />

          <el-radio :label="7" style="margin-top: 16px">
            <el-select
              style="width: 100px; height: 32px; margin: 0 8px 0 0"
              v-model="form.num41"
            >
              <el-option
                v-for="item in fiveyear"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
            <span>年后的</span>
            <el-select
              style="width: 100px; height: 32px; margin: 0 8px"
              v-model="form.num42"
            >
              <el-option
                v-for="item in fivemouth"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
            <span>月</span>
            <el-select
              style="width: 100px; height: 32px; margin: 0 8px"
              v-model="form.num43"
            >
              <el-option
                v-for="item in fourdayOptions"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
            <span>日失效</span>
          </el-radio>
        </el-radio-group>
      </div>

      <!-- 5.标题 -->
      <y-title label="等级差异倍数设置" style="margin-top: 30px"></y-title>
      <!-- 5.表单区域 -->
      <div class="item-box last_item_box">
        <el-form
          :model="form"
          label-width="100px"
          label-position="right"
          style="margin-left: 14px"
        >
          <el-form-item label="等级差异积分：">
            <div>
              <span
                >等级差异成长值=基础成长值 x 等级差异倍数 x
                会员生日倍数（注：基于订单金额计算成长值，若出现小数，则向下取整发放）</span
              >
            </div>
          </el-form-item>
          <div
            v-for="(item, index) in DetailByIdList"
            style="
              display: flex;
              justify-content: space-around;
              width: 800px;
              margin-bottom: 16px;
              padding-left: 7px
            "
            :key="'DetailByIdList' + item.gradeCode"
          >
            <div class="flexc-cen-x">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.gradeName"
                placement="left-start"
              >
                <span
                  class="grade-name"
                  >{{ item.gradeName }}</span
                >
              </el-tooltip>

              <el-input
                style="width: 100px; margin-right: 8px"
                v-model="form['vip' + (index + 1)]"
                v-numHave2Decimal
                @blur="handleMoney"
              ></el-input>
              <!-- :value="form['birthVip' + (index + 1)]" -->
              <!-- @input="handleInput('vip' + (index + 1), $event.target.value)" -->
              <span>倍</span>
            </div>
            <div class="flexc-cen-x">
              <span>会员生日当天</span>
              <el-input
                style="width: 100px; margin: 0 8px"
                v-model="form['birthVip' + (index + 1)]"
                v-numeric-only
                v-numNoZero
              ></el-input>
              <!-- :value="form['birthVip' + (index + 1)]" -->
              <!-- @input="handleInput('birthVip' + (index + 1), $event.target.value)" -->
              <span>倍</span>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="global-bottom-btn">
      <!-- 6.保存 -->
      <y-button type="blue" @click="save" key="baocun-btn">保存</y-button>
    </div>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :postForm="postForm"
      @transferName="goodsPopupBtn"
      :scoresCardId="this.MemberSystemInfo.scoresCardId"
    >
    </select-goods>
  </div>
</template>

<script>
import selectGoods from "@/components/select-goods.vue";
import {
  getGrowRule,
  saveGrowRule,
  getDetailById,
} from "@/api/loyalty/growthRules";
export default {
  name: "growth_rules",
  components: {
    selectGoods,
  },
  props: [],
  data() {
    return {
      DetailByIdList: [],
      goodsArr: [],
      selectedValue: 0,
      goodsState: false,
      MemberSystemInfo: {}, // 当前会员体系详情
      postForm: [],

      // 1.表单数据
      form: {
        scoresCardGrowRuleId: "",
        num11: "",
        num12: "",
        num2: "",
        num31: "",
        num32: "",
        num41: "",
        num42: "",
        num43: "",
        ruleName: "成长值", //成长值别名
        baseMoney: "", //每消费多少元
        baseGrowVal: "", //每消费多少元获得xx成长值
        costType: 0, //成长值扣减规则： 0不扣减成长值 1按退款比例扣减成长值
        validType: 0, //成长值有效期 0永久有效 1X天后失效 2X月后失效 3X年后失效 4当月底失效 5当年底失效 6X月后X日失效 7X年后X月X日失效
        vip1: "", //等级成长值倍数VIPA
        vip2: "",
        vip3: "",
        vip4: "",
        vip5: "",
        birthVip1: "", //生日当天倍数VIPA
        birthVip2: "",
        birthVip3: "",
        birthVip4: "",
        birthVip5: "",
        day: "", //日 最大31
        month: "", //月 最大12
        dateNum: "", //日期偏移值 X年中的X，X月中的X；X月后，X年后的X
        itemSelectType: 0, //商品选择
      },

      // 2.年月日
      YTD: [
        {
          value: "1",
          label: "天",
        },
        {
          value: "2",
          label: "月",
        },
        {
          value: "3",
          label: "年",
        },
      ],
      // 3.当月/当年
      currentYT: [
        {
          value: "1",
          label: "当月",
        },
        {
          value: "2",
          label: "当年",
        },
      ],
      // 成长值有效期
      // 1-24
      fourmouth: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
        {
          value: 6,
          label: "6",
        },
        {
          value: 7,
          label: "7",
        },
        {
          value: 8,
          label: "8",
        },
        {
          value: 9,
          label: "9",
        },
        {
          value: 10,
          label: "10",
        },
        {
          value: 11,
          label: "11",
        },
        {
          value: 12,
          label: "12",
        },
        {
          value: 13,
          label: "13",
        },
        {
          value: 14,
          label: "14",
        },
        {
          value: 15,
          label: "15",
        },
        {
          value: 16,
          label: "16",
        },
        {
          value: 17,
          label: "17",
        },
        {
          value: 18,
          label: "18",
        },
        {
          value: 19,
          label: "19",
        },
        {
          value: 20,
          label: "20",
        },
        {
          value: 21,
          label: "21",
        },
        {
          value: 22,
          label: "22",
        },
        {
          value: 23,
          label: "23",
        },
        {
          value: 24,
          label: "24",
        },
      ],
      // 添加这个属性
      fourdayOptions: [], // 添加这个属性
      // 1-31 //日
      fourday: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
        {
          value: 6,
          label: "6",
        },
        {
          value: 7,
          label: "7",
        },
        {
          value: 8,
          label: "8",
        },
        {
          value: 9,
          label: "9",
        },
        {
          value: 10,
          label: "10",
        },
        {
          value: 11,
          label: "11",
        },
        {
          value: 12,
          label: "12",
        },
        {
          value: 13,
          label: "13",
        },
        {
          value: 14,
          label: "14",
        },
        {
          value: 15,
          label: "15",
        },
        {
          value: 16,
          label: "16",
        },
        {
          value: 17,
          label: "17",
        },
        {
          value: 18,
          label: "18",
        },
        {
          value: 19,
          label: "19",
        },
        {
          value: 20,
          label: "20",
        },
        {
          value: 21,
          label: "21",
        },
        {
          value: 22,
          label: "22",
        },
        {
          value: 23,
          label: "23",
        },
        {
          value: 24,
          label: "24",
        },
        {
          value: 25,
          label: "25",
        },
        {
          value: 26,
          label: "26",
        },
        {
          value: 27,
          label: "27",
        },
        {
          value: 28,
          label: "28",
        },
        {
          value: 29,
          label: "29",
        },
        {
          value: 30,
          label: "30",
        },
        {
          value: 31,
          label: "31",
        },
      ],
      // 1-5
      fiveyear: [
        {
          value: 6,
          label: "当年",
        },
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
      ],
      // 1-12 //月
      fivemouth: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
        {
          value: 6,
          label: "6",
        },
        {
          value: 7,
          label: "7",
        },
        {
          value: 8,
          label: "8",
        },
        {
          value: 9,
          label: "9",
        },
        {
          value: 10,
          label: "10",
        },
        {
          value: 11,
          label: "11",
        },
        {
          value: 12,
          label: "12",
        },
      ],
    };
  },

  watch: {
    // 监听每个月多少天
    "form.num42": function (newVal) {
      // 清空之前的日选项
      // this.form.num43 = '';
      this.fourdayOptions = [];

      // 获取选定月份的天数
      const month = parseInt(newVal);
      const daysInMonth = new Date(2023, month, 0).getDate();

      // 添加新的日选项
      this.fourdayOptions = this.fourday.slice(0, daysInMonth);
    },
    // 'form': {
    // handler: function(newForm, oldForm) {
    //   for (let key in newForm) {
    //     if (newForm[key] === '0') {
    //       newForm[key] = '';
    //     }
    //   }
    // },
    // deep: true,
    // },
  },

  created() {
    this.buriedPoint(1, "忠诚度管理", "忠诚度管理", "成长值计算规则");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    this.searchList();
  },
  mounted() {
    // this.$nextTick(() => {
    //   let baocunBtn = document.getElementById("baocun");
    //   baocunBtn.offsetHeight = 34 + "px";
    //   console.log(baocunBtn);
    // });

    this.getDetailById();
  },
  methods: {
    handleInput(propertyName, value) {
      if (value == "0") {
        this.form[propertyName] = "";
      } else {
        this.form[propertyName] = value;
      }
    },
    // 限制输入框不能输入0
    // checkZero() {
    //   if (this.form.baseMoney === "0") {
    //     this.form.baseMoney = "";
    //   }
    // },
    // 限制选择单选时，后面的输入框、下拉框必选
    // handleNumInput() {
    //   if (this.isRadioSelected === 1) {
    //     if (!this.form.num11 || !this.form.num12) {
    //       this.form.num11 = ""; // 输入框设为空
    //       this.form.num12 = null; // 下拉框设为null
    //     }
    //   }
    // },
    handleGrowValInput() {
      this.form.baseGrowVal = this.form.baseGrowVal.replace(/[^\d]/g, "");
      // 限制输入框不能输入0
      if (this.form.baseGrowVal === "0") {
        this.form.baseGrowVal = "";
      }
    },
    handleNumInput() {
      this.form.num11 = this.form.num11.replace(/[^\d]/g, "");
      // 限制输入框不能输入0
      if (this.form.num11 === "0") {
        this.form.num11 = "";
      }
    },

    // 根据会员体系ID查询详情
    getDetailById() {
      getDetailById({
        cardId: this.MemberSystemInfo.scoresCardId,
      }).then((res) => {
        this.DetailByIdList = res.data.gradeList;
      });
    },
    goodsPopupBtn(event, state) {
      // 点击弹窗中的确定按钮
      if (state == 1) {
        this.goodsArr = event.map((item) => {
          let obj = {
            itemName: item.itemTitle,
            itemImage: item.picUrl,
            itemPrice: item.price,
            itemSkuId: item.numIid,
            scoresCardId: this.MemberSystemInfo.scoresCardId,
            scoresCardGrowRuleId: this.form.scoresCardGrowRuleId,
            channelSellerManageId: item.channelSellerManageId,
            platform: item.platform,
          };
          return obj;
        });
        this.postForm = JSON.parse(JSON.stringify(event));
      }
      this.goodsState = false;
      // 点击弹窗中的确定按钮
    },
    // 获取 查询
    searchList() {
      // 检索数据
      getGrowRule(
        this.MemberSystemInfo.scoresCardId,
        this.form.scoresCardGrowRuleId
      ).then((res) => {
        // getGrowRule(1423).then((res) => {
        if (res.code == 200) {
          // this.form = res.data;
          Object.keys(this.form).map((key) => {
            this.form[key] = res.data[key] || this.form[key];
          });
          this.goodsArr = res.data.shopDTOList || [];
          this.postForm = res.data.shopDTOList.map((item) => {
            let obj = {
              itemTitle: item.itemName,
              picUrl: item.itemImage,
              price: item.itemPrice,
              numIid: item.itemSkuId,
              channelSellerManageId: item.channelSellerManageId,
            };
            return obj;
          });
          if (res.data.validType == 0) {
            this.form.validType = 0;
          } else if (res.data.validType == 1) {
            this.form.validType = 1;
            this.form.num11 = res.data.dateNum;
            this.form.num12 = "天";
          } else if (res.data.validType == 2) {
            this.form.validType = 1;
            this.form.num11 = res.data.dateNum;
            this.form.num12 = "月";
          } else if (res.data.validType == 3) {
            this.form.validType = 1;
            this.form.num11 = res.data.dateNum;
            this.form.num12 = "年";
          } else if (res.data.validType == 4) {
            this.form.validType = 4;
            this.form.num2 = "当月";
          } else if (res.data.validType == 5) {
            this.form.validType = 4;
            this.form.num2 = "当年";
          } else if (res.data.validType == 6) {
            this.form.validType = 6;
            this.form.num31 = res.data.dateNum;
            this.form.num32 = String(res.data.day);
          } else if (res.data.validType == 7) {
            this.form.validType = 7;
            this.form.num41 = res.data.dateNum;
            this.form.num42 = res.data.month;
            //  回显
            this.form.num43 = res.data.day;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 保存
    save() {
      if (this.form.validType == 1) {
        if (this.form.num11 == "") {
          this.$message.error("请输入成长值有效期天数");
          return;
        } else if (this.form.num12 == "") {
          this.$message.error("请输入成长值有效期天数");
          return;
        }
      } else if (this.form.validType == 4) {
        if (this.form.num2 == "") {
          this.$message.error("请选择成长值有效期天数");
          return;
        }
      } else if (this.form.validType == 6) {
        if (this.form.num31 == "") {
          this.$message.error("请选择成长值有效期天数");
          return;
        } else if (this.form.num32 == "") {
          this.$message.error("请选择成长值有效期天数");
          return;
        }
      } else if (this.form.validType == 7) {
        if (this.form.num41 == "") {
          this.$message.error("请选择成长值有效期天数");
          return;
        } else if (this.form.num42 == "") {
          this.$message.error("请选择成长值有效期天数");
          return;
        } else if (this.form.num43 == "") {
          this.$message.error("请选择成长值有效期天数");
          return;
        }
      }

      // else if(this.form.validType==2){
      //   if(this.form.num21==''){
      //     this.$message.error('请选择成长值有效期天数')
      //     return
      //   }
      // }
      // else if(this.form.validType==3){
      //   if(this.form.num31==''){
      //     this.$message.error('请选择成长值有效期天数')
      //     return
      //   }else if(this.form.num32==''){
      //     this.$message.error('请输入成长值有效期天数')
      //     return
      //   }
      // }
      // else if(this.form.validType==4){
      //   if(this.form.num41==''){
      //     this.$message.error('请选择成长值有效期天数')
      //     return
      //   }else if(this.form.num42==''){
      //     this.$message.error('请输入成长值有效期天数')
      //     return
      //   }else if(this.form.num43==''){
      //     this.$message.error('请输入成长值有效期天数')
      //     return
      //   }
      // }
      if (this.form.baseMoney == "") {
        this.$message.error("请输入每消费多少元");
        return;
      } else if (this.form.baseGrowVal == "") {
        this.$message.error("请输入获取多少成长值");
        return;
      } else if (this.form.itemSelectType == null) {
        this.$message.error("请选择商品选择");
        return;
      }
      this.$confirm(
        "成长值规则修改确认后，新增订单将按照最新的成长值规则计算成长值，请尽快同步买家端成长值规则说明。",
        "提示",
        {
          confirmButtonText: "保存",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.saveGrowRule(); // 在点击保存按钮后调用saveGrowRule方法
      });
    },
    // 保存
    saveGrowRule() {
      let obj = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        scoresCardGrowRuleId: this.form.scoresCardGrowRuleId,
        ruleName: this.form.ruleName,
        baseMoney: this.form.baseMoney,
        baseGrowVal: this.form.baseGrowVal,
        itemSelectType: this.form.itemSelectType,
        costType: this.form.costType,
        vip1: this.form.vip1,
        vip2: this.form.vip2,
        vip3: this.form.vip3,
        vip4: this.form.vip4,
        vip5: this.form.vip5,
        birthVip1: this.form.birthVip1,
        birthVip2: this.form.birthVip2,
        birthVip3: this.form.birthVip3,
        birthVip4: this.form.birthVip4,
        birthVip5: this.form.birthVip5,
        shopDTOList: [
          // scoresCardId:''
        ],
      };
      if (this.form.validType == 0) {
        obj.validType = 0;
      } else if (this.form.validType == 1) {
        if (this.form.num12 == 1) {
          //天
          obj.validType = 1;
          obj.dateNum = this.form.num11;
        } else if (this.form.num12 == 2) {
          //月
          obj.validType = 2;
          obj.dateNum = this.form.num11;
        } else if (this.form.num12 == 3) {
          //年
          obj.validType = 3;
          obj.dateNum = this.form.num11;
        }
      } else if (this.form.validType == 4) {
        if (this.form.num2 == 1) {
          //当月
          obj.validType = 4;
        } else if (this.form.num2 == 2) {
          //当年
          obj.validType = 5;
        }
      } else if (this.form.validType == 6) {
        obj.validType = 6;
        obj.dateNum = this.form.num31;
        obj.day = this.form.num32;
      } else if (this.form.validType == 7) {
        obj.validType = 7;
        if (this.form.num41 == 6) {
          obj.dateNum = null;
          obj.month = this.form.num42;
          obj.day = this.form.num43;
        } else {
          obj.dateNum = this.form.num41;
          obj.month = this.form.num42;
          obj.day = this.form.num43;
        }
      }
      if (this.form.itemSelectType == 1 || this.form.itemSelectType == 2) {
        obj.shopDTOList = this.goodsArr;
      }
      saveGrowRule(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
        }
      });
    },
    handleMoney(event) {
      if (Number(event.target.value) == Number(0)) {
        event.target.value = "0.01";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.growth_rules {
  .item-box {
    margin-top: 16px;
    // margin-bottom: 40px;
  }
}

.grade-name{
  min-width: 90px;
  margin-right: 8px;
  text-align: left;
  display: inline-block;
  line-height: 32px;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}

/deep/.el-form-item__label {
  padding: 0px 0px 0 0;
}

.last_item_box {
  /deep/.el-form-item--small.el-form-item {
    margin-left: -98px;
  }
  /deep/.el-form-item--small.el-form-item:nth-child(1) {
    margin-left: 0px;
  }
}
</style>
